import { formatAmount } from '../../utils/formatters'

interface RecordPaymentSummaryBannerProps {
  invoiceNumber: string
  partyName: string
  totalAmount: number
  paymentsReceived: number
  invoiceCurrency: string
}

export function RecordPaymentSummaryBanner({
  invoiceNumber, partyName, totalAmount, paymentsReceived, invoiceCurrency,
}: RecordPaymentSummaryBannerProps): JSX.Element {
  return (
    <div className="rounded-lg bg-muted el-p-sm flex items-center justify-between text-sm">
      <div>
        <span className="font-mono font-medium">{invoiceNumber}</span>
        <span className="text-foreground-secondary ml-3">{partyName}</span>
      </div>
      <div className="flex items-center gap-4 font-mono text-sm">
        <span className="text-foreground-secondary">
          Total: {formatAmount(totalAmount, invoiceCurrency)}
        </span>
        {paymentsReceived > 0 && (
          <span className="text-foreground-secondary">
            Paid: {formatAmount(paymentsReceived, invoiceCurrency)}
          </span>
        )}
        <span className="font-semibold">
          Due: {formatAmount(totalAmount - paymentsReceived, invoiceCurrency)}
        </span>
      </div>
    </div>
  )
}
